<div class="modal-header">
    <h4 class="modal-title">Email Address</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="emailAddress" *ngIf="emailAddress">
        <dxi-item itemType="group">
            <dxi-item dataField="name"></dxi-item>
            <dxi-item dataField="email"></dxi-item>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
